"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterProvider = void 0;
var react_aria_components_1 = require("react-aria-components");
Object.defineProperty(exports, "RouterProvider", { enumerable: true, get: function () { return react_aria_components_1.RouterProvider; } });
//# sourceMappingURL=RouterProvider.js.map